<template>
  <Transition name="fade">
    <div v-if="isOpen" class="dialog-outer_wrap" @click="closeDialog">
      <div
        ref="dialogInnerWrapRef"
        class="dialog-inner_wrap"
        :class="heightWrapperClass"
        :style="fitContentStyle"
        @click.stop
      >
        <component :is="$store.state.componentDialog">
          <template #header_close>
            <ButtonClose />
          </template>
        </component>
      </div>
    </div>
  </Transition>
</template>

<script>
import { ref, computed } from "vue";
import { useScrollLock, useWindowSize } from "@vueuse/core";
import { useStore } from "vuex";
import ButtonClose from "../Recurring/ButtonClose.vue";
// NUMBERS AND CRM DIALOGS
import AnnouncementDialog from "./DialogComponents/AnnouncementDialog.vue";
import InstructionDialog from "./DialogComponents/InstructionDialog.vue";
import WelcomeWhatsappDialog from "./DialogComponents/WelcomeWhatsappDialog.vue";
import AddNumberDialog from "./DialogComponents/AddNumberDialog.vue";
import AddNumberViberDialog from "./DialogComponents/AddNumberViberDialog.vue";
import AddNumberTelegramDialog from "./DialogComponents/AddNumberTelegramDialog.vue";
import AddNumberWhatsappDialog from "./DialogComponents/AddNumberWhatsappDialog.vue";
import WhichCrmSystemDialog from "./DialogComponents/WhichCrmSystemDialog.vue";
import TariffSelectNumberDialog from "./DialogComponents/TariffSelectNumberDialog.vue";
import AnotherPaymentDialog from "./DialogComponents/AnotherPaymentDialog.vue";
// INFORMATION DIALOGS
import InformationDialog from "./DialogComponents/InformationDialog.vue";
import HelpDialog from "./DialogComponents/HelpDialog.vue";
import SuccessActivationDialog from "./DialogComponents/SuccessActivationDialog.vue";
// IN ACTIVATION PAGE
import TwoFactorAuthDialog from "./DialogComponents/TwoFactorAuthDialog.vue";
// NUMBER SETTINGS
import SettingsNumberDialog from "@/components/Dialog/DialogComponents/SettingsNumberDialog.vue";
import ApiKeyRefreshDialog from "./DialogComponents/ApiKeyRefreshDialog.vue";
import NumberTagsAddEditDialog from "./DialogComponents/NumberTagsAddEditDialog.vue";
import NumberTagsDeleteDialog from "./DialogComponents/NumberTagsDeleteDialog.vue";
import WebhookAddEditDialog from "@/components/webhook/WebhookAddEditDialog.vue";
import WebhookDeleteDialog from "@/components/webhook/WebhookDeleteDialog.vue";

// Telephony
import NumberSettingsDialog from "@/components/Telephony/Dialog/NumberSettingsDialog.vue";
import ApiKeyDialog from "@/components/Telephony/Dialog/ApiKeyDialog.vue";
import WebhookDialog from "@/components/Telephony/Dialog/WebhookDialog.vue";
import WebhookDelete from "@/components/Telephony/Dialog/WebhookDelete.vue";
import SelectSipDialog from "@/components/Telephony/Dialog/SelectSipDialog.vue";
import DeleteSipDialog from "@/components/Telephony/Dialog/DeleteSipDialog.vue";
import TelephonyCrmDialog from "@/components/Telephony/Dialog/TelephonyCrmDialog.vue";
import TiktokCrmDialog from "@/components/Tiktok/Dialog/TiktokCrmDialog.vue";
import TiktokAccountSettingsDialog from "@/components/Tiktok/Dialog/TiktokAccountSettingsDialog.vue";
import TiktokApiKeyRefreshDialog from "@/components/Tiktok/Dialog/TiktokApiKeyRefreshDialog.vue";
import TiktokLogoutDialog from "@/components/Tiktok/Dialog/TiktokLogoutDialog.vue";
import TiktokTagAddEditDialog from "@/components/Tiktok/Dialog/TiktokTagAddEditDialog.vue";
import TiktokTagDeleteDialog from "@/components/Tiktok/Dialog/TiktokTagDeleteDialog.vue";
import TiktokWebhookAddEditDialog from "@/components/Tiktok/Dialog/TiktokWebhookAddEditDialog.vue";
import TiktokWebhookDeleteDialog from "@/components/Tiktok/Dialog/TiktokWebhookDeleteDialog.vue";
import CreateSip from "@/components/Telephony/Dialog/CreateSip.vue";
import EditExtensionDialog from "@/components/Telephony/Dialog/EditExtensionDialog.vue";
import ActivationLinkDialog from "./DialogComponents/ActivationLinkDialog.vue";
import InvoiceDialog from "@/components/Dialog/DialogComponents/InvoiceDialog.vue";

const notClosedDialogs = ["TwoFactorAuthDialog"];

export default {
  components: {
    ButtonClose,
    AddNumberDialog,
    AddNumberViberDialog,
    AddNumberTelegramDialog,
    AddNumberWhatsappDialog,
    WhichCrmSystemDialog,
    InformationDialog,
    WelcomeWhatsappDialog,
    TwoFactorAuthDialog,
    SuccessActivationDialog,
    AnnouncementDialog,
    InstructionDialog,
    TariffSelectNumberDialog,
    // TODO: refactor bg=>img, merge components, rename
    HelpDialog,
    AnotherPaymentDialog,

    WebhookAddEditDialog,
    WebhookDeleteDialog,
    SettingsNumberDialog,
    ApiKeyRefreshDialog,
    NumberTagsAddEditDialog,
    NumberTagsDeleteDialog,
    NumberSettingsDialog,
    ApiKeyDialog,
    WebhookDialog,
    WebhookDelete,
    SelectSipDialog,
    DeleteSipDialog,
    TelephonyCrmDialog,
    TiktokCrmDialog,
    TiktokAccountSettingsDialog,
    TiktokApiKeyRefreshDialog,
    TiktokLogoutDialog,
    TiktokTagAddEditDialog,
    TiktokTagDeleteDialog,
    TiktokWebhookAddEditDialog,
    TiktokWebhookDeleteDialog,
    CreateSip,
    EditExtensionDialog,
    ActivationLinkDialog,
    InvoiceDialog
  },
  setup() {
    const { height } = useWindowSize();
    const isLocked = useScrollLock(document.body);
    const store = useStore();

    const dialogInnerWrapRef = ref(null);

    const isOpen = computed(() => {
      isLocked.value = store.state.isDialogOpen;
      return store.state.isDialogOpen;
    });

    const heightWrapperClass = computed(() => {
      const widestComponentNameList = [
        "AddNumberDialog",
        "AddNumberViberDialog",
        "AddNumberTelegramDialog",
        "AddNumberWhatsappDialog",
        "AnnouncementDialog",
        "InstructionDialog",
        "SelectSipDialog",
        "TelephonyCrmDialog",
        "TiktokCrmDialog",
      ];

      const wideContentComponentNameList = [
        "TariffSelectNumberDialog",
        "HelpDialog",
        "WhichCrmSystemDialog",
      ];

      const storeDialog = store.state.componentDialog;

      return widestComponentNameList.includes(storeDialog)
        ? "dialog-widest"
        : wideContentComponentNameList.includes(storeDialog)
        ? "dialog-content"
        : "dialog-standard";
    });

    const fitContentStyle = computed(
      () =>
        //   store.state.componentDialog === "InformationDialog"
        //     ? { maxWidth: "fit-content" }
        //     : ""
        ""
    );

    const dialogInnerWrapState = computed(() => {
      // console.log(1, dialogInnerWrapRef?.value?.clientHeight);
      return dialogInnerWrapRef?.value?.clientHeight || 0;
    });

    const heightWrapState = computed(() => {
      if (!height?.value || !dialogInnerWrapState.value) return;
      return height.value > dialogInnerWrapState.value
        ? "auto"
        : "calc(100vh - 80px)";
    });

    const closeDialog = () => {
      if (notClosedDialogs.includes(store.state.componentDialog)) {
        return;
      } else {
        const nextDialog = store.getters.getNextDialog;

        if (!!nextDialog) {
          store.commit("setDialog", nextDialog);
          store.commit("setNextDialog");
        } else {
          store.commit("closeDialog");
        }
      }
    };

    return {
      isLocked,
      isOpen,
      closeDialog,
      heightWrapperClass,
      dialogInnerWrapRef,
      heightWrapState,
      height,
      fitContentStyle,
    };
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  &-outer_wrap {
    position: fixed;
    overflow: auto;
    width: 100vw;
    height: 100vh;
    top: 0;
    background-color: rgba(#08050cff, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 11;
  }

  &-inner_wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    width: max-content;
    min-width: 300px;
    max-height: calc(100% - 80px);
    overflow-y: auto;
    // height: v-bind(heightWrapState);
    /* margin: 25px 0; */
    margin-left: -2px;
    transform: translate(-50%, -50%);
    border-radius: 7px;
    background-color: white;
  }

  &-widest {
    max-width: 750px;
    width: calc(100% - 20px);
  }

  &-content {
    max-width: max-content;
    width: max(100% - 20px);
  }

  &-standard {
    min-width: 420px;
    max-width: 560px;
  }

  @media screen and (max-width: 580px) {
    &-inner_wrap {
      max-width: calc(100% - 20px);
    }
    &-standard {
      min-width: 0;
    }
  }

  @media screen and (max-width: 370px) {
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
</style>
